module.exports = __webpack_public_path__ + "img/betsson.c00c2e38.svg";